//fast way to remove all children from the element
export function clearElement(el) {
  while (el.firstChild) {
    el.removeChild(el.firstChild);
  }
}

// extract parameters from URL query
export const getUrlParams = (search = "") => {
  const hashes = search.slice(search.indexOf("?") + 1).split("&");
  return hashes.reduce((acc, hash) => {
    // eslint-disable-next-line
    const [key, val] = hash.split("=");
    return {
      ...acc,
      [key]: decodeURIComponent(val),
    };
  }, {});
};

// exclude html tags from string
export const excludeHtmlTagsFromString = (str) => {
  if (str === null || str === "") {
    return false;
  } else {
    str = str.toString();
    return str.replace(/(<([^>]+)>)/gi, "");
  }
};

/*finds corresponding properties from target with those in arr
returns key value pairs as & delimited string*/
export function createQuery(target, arr) {
  const qs = [];
  for (const key in arr) {
    qs.push(key + "=" + target[key]);
  }
  return qs.join("&");
}

/* Return the parent element which has the className */
export function hasSomeParentTheClass(element, className) {
  if (element.className.split(" ").indexOf(className) >= 0) return element;
  return (
    element.parentNode && hasSomeParentTheClass(element.parentNode, className)
  );
}

/* Add a listener to multiple events */
export function addMultiEvents(element, eventNames, listener) {
  const events = eventNames.split(" ");
  for (let i = 0, iLen = events.length; i < iLen; i++) {
    element.addEventListener(events[i], listener, false);
  }
}
